import React, { useState, useRef, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";

export default function DetailsNavbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const location = useLocation();
  const headerRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const toggleDropdown = (forceState = null) => {
    setIsDropdownOpen((prev) =>
      forceState !== null ? forceState : !prev
    );
  };

  // Close menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
  }, [location.pathname]);

  // Click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        headerRef.current &&
        !headerRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // ESC key handling
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        setIsMenuOpen(false);
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <header ref={headerRef}>
      <section className="nav-section" style={{
            background: "transparent",
          }}>
        <nav className="main-navbar">
        <NavLink to='/'  className="logo" style={{ background: "transparent" , cursor:"pointer"}}>
              <img
                src="/assets/images/credence-pay-logo.png"
                alt="Credence Resource Management, LLC logo"
                width="auto"
              />
            </NavLink>

          {/* MENU TOGGLE */}
          <button className="main-menu-toggle" aria-label="Toggle navigation menu" aria-expanded="false" aria-controls="main-navigation" onClick={toggleMenu}>
            ☰
          </button>

          <ul className={`main-nav-links ${isMenuOpen ? "active" : ""}`}>
            <li>
              <NavLink to="/" className="main-nav">Home</NavLink>
            </li>

            <li>
              <NavLink to="/About-Us" className="main-nav">
                About Us
              </NavLink>
            </li>

            {/* DROPDOWN */}
            <li className={isDropdownOpen ? "open" : ""}>
              <a
              href="#"
              style={{cursor:"pointer"}}
                className="main-nav"
                aria-haspopup="true"
                aria-expanded="false"
                onClick={(e) => {
                  e.preventDefault();
                  toggleDropdown();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    toggleDropdown();
                  }
                  if (e.key === "Escape") {
                    toggleDropdown(false);
                  }
                }}
              >
                Rights & Policies ▾
              </a>

              <div className="sub-menu" role="submenu">
                <NavLink to="/Privacy-Policy">Privacy</NavLink>
                <NavLink to="/Legal">Your Legal Rights</NavLink>
                <NavLink to="/Refund-Policy">Refund Policy</NavLink>
                <NavLink to="/Sms-Policy">SMS Policy</NavLink>
                <NavLink to="/Credence-Responsible-Vulnerability-Disclosure">Responsible Reporting Policy</NavLink>
              </div>
            </li>

            <li>
              <NavLink to="/Contact-Us" className="main-nav">
                Contact
              </NavLink>
            </li>
          </ul>
        </nav>
      </section>
    </header>
  );
}